module.exports = __webpack_public_path__ + "img/bag.3d8fd01e.png";